import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeDocNumber = async ({ docId, docNumber }) => {
  return await request.put(
    `Docs/doc_number/${docId}?docNumber=${docNumber}`,
    null,
    'При изменении номера документа произошла ошибка',
    'Error'
  );
};

const useChangeDocNumber = () => {
  const mutation = useMutation(changeDocNumber, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocNumber: mutation.isLoading,
    changeDocNumber: mutation.mutateAsync,
  };
};
export default useChangeDocNumber;
